import React, { useState, useMemo } from 'react';
import { EventRuleViewer } from '@src/pages/journey-map/components';
import { Modal, Popover, Tooltip, type PopoverProps } from 'antd';
import { useCriticalEvents } from '@src/services/queries';
import StaryellowIcon from '@src/icons/Staryellow.svg';
import styled from 'styled-components';

const StarIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
`;

const NameContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
`;

interface IProps {
  name: string;
  rule?: any;
  supportHover?: boolean;
  supportModal?: boolean;
  popoverProps?: PopoverProps;
  style?: React.CSSProperties;
}

const EventShowcase: React.FC<IProps> = ({
  name,
  rule,
  supportHover = true,
  supportModal = false,
  style = {},
  popoverProps = {},
}) => {
  const [open, setOpen] = useState(false);
  const { data } = useCriticalEvents();

  const isMilestone = useMemo(() => {
    const event = data?.criticalEvents.find((event) => event.name === name);
    return event?.is_milestone ?? false;
  }, [data, name]);

  const content = (
    <NameContainer style={style}>
      {name}
      {isMilestone && (
        <Tooltip title="Milestone">
          <StaryellowIcon />
        </Tooltip>
      )}
    </NameContainer>
  );
  return (
    <div onDoubleClick={() => setOpen(true)}>
      {supportHover ? (
        <Popover
          placement={'rightTop'}
          getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
          content={<EventRuleViewer name={name} rule={rule} />}
          title=""
          {...popoverProps}
        >
          {content}
        </Popover>
      ) : (
        content
      )}
      <Modal open={open && supportModal} onCancel={() => setOpen(false)}>
        <EventRuleViewer name={name} rule={rule} />
      </Modal>
    </div>
  );
};

export default EventShowcase;
